import React from 'react';
import { useTranslation } from 'react-i18next';
import './RiskFixerCard.css';

const RiskFixerCard = () => {
  const { t } = useTranslation();
  const product = t('products.riskFixer', { returnObjects: true });

  return (
    <div className="product-card card riskfixer-card">
      <div className="product-header">
        <div className="product-icon gradient-green">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M6 7h12"/>
            <path d="M6 11h8"/>
            <circle cx="18" cy="8" r="2"/>
            <path d="M20 6l-2 2-2-2"/>
          </svg>
        </div>
        <h3 className="product-title">{product.title}</h3>
        <p className="product-subtitle">{product.subtitle}</p>
      </div>
      
      <div className="product-features">
        {product.features.map((feature, index) => (
          <div key={index} className="feature-item">
            <div className="feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9,11 12,14 22,4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="platform-support">
        <h4 className="platform-title">{product.platformTitle}</h4>
        <div className="platform-list">
          {product.platforms.map((platform, index) => (
            <div key={index} className={`platform-item ${platform.status}`}>
              <span className="platform-icon">{platform.icon}</span>
              <span className="platform-name">{platform.name}</span>
            </div>
          ))}
        </div>
      </div>
      
      <div className="product-cta-dual">
        <div className="dual-buttons">
          <a 
            href={product.downloadMac} 
            className="btn btn-primary download-btn"
            download="riskfixer_0.1.0_aarch64.dmg"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7,10 12,15 17,10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            <span>{product.ctaMac}</span>
          </a>
          <a 
            href={product.downloadWin} 
            className="btn btn-primary download-btn"
            download="riskfixer_0.1.0_x64-setup.exe"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7,10 12,15 17,10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            <span>{product.ctaWin}</span>
          </a>
        </div>
        
        {product.secondaryCta && (
          <div className="secondary-actions">
            <a href="#guide" className="secondary-link">{product.secondaryCta.guide}</a>
            <span className="divider">·</span>
            <a href="#community" className="secondary-link">{product.secondaryCta.community}</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiskFixerCard;